import Head from "next/head";
import { PropsWithChildren } from "react";

const pageTitle = (title?: string) => {
  return title ? `${title} | ShelfCycle` : "ShelfCycle";
};

interface PageHeadProps {
  title?: string;
}
export const PageHead = (props: PropsWithChildren<PageHeadProps>) => (
  <Head>
    <title>{pageTitle(props.title)}</title>
    {props.children}
  </Head>
);
